module.exports = __webpack_public_path__ + "static/images/callout_1.5bc33ba83563c2893d6c99af2febd199.jpg";